import * as React from 'react'
import { useDispatch } from 'react-redux'
import { styled, useTheme } from '@mui/material/styles'

import { setAllStikisOnPageUnselectedAsync } from '../../redux/features/stikis/stikisSlice'

import AppBar from '@mui/material/AppBar'
import Stack from '@mui/material/Stack'
import Button from '@mui/material/Button'
import Grid from '@mui/material/Grid'
import Box from '@mui/material/Box'
import Toolbar from '@mui/material/Toolbar'
import Typography from '@mui/material/Typography';
import Container from '@mui/material/Container'
import Link from '@mui/material/Link'

import { useSelector } from 'react-redux'
import { selectPage } from '../../redux/features/pages/pagesSlice'


import StaticTopMenu from './StaticTopMenu'
import StikisField from '../../redux/features/stikis/StikisField'

// import { loadStaticDataAsync } from '../redux/features/pages/pagesSlice'

const classes = {
  callToAction: {
    bgcolor: (theme) => theme.palette.grey[200],
    pt: 5,
    pb: 5,
  }
}

function StaticPolicy(props) {
  return (
    <React.Fragment>
      <main>
        <Box
          sx={{
            pt: 5,
            pb: 10,
          }}
        >
          <Container
            maxWidth='md'
          >
            <Typography
              component='h3'
              variant='h3'
              align='center'
              color='text.primary'
              gutterBottom
            >
              Privacy Policy
            </Typography>
          </Container>
          <Container maxWidth='md'>
            <p>
              Stikis.com only asks for information that it needs to provide 
              service to its users. What information it does ask will never 
              be provided to a third party unless required to by law. Where 
              we do ask for information, we will always try to make clear why 
              we need it so you can decide whether it benefits you to provide
              it.
            </p>
            <p>
              We will:
            </p>
            <ul>
              <li>Only ask for information required to provide the service.</li>
              <li>Always explain what the information is needed for.</li>
              <li>Always provide opportunity for information to be withdrawn.</li>
              <li>Not give the information to anyone else unless you tell us to or if we are required by law.</li>
            </ul>

            <Typography variant='h4'>What we ask for</Typography>
            <p>
              To use stikis you can register with 
              stikis locally, or sign in with any OpenID identity. There is no
              difference in what different kinds of users can do, but the information
              that stikis requires of each is slightly different. The tables below
              list what we ask for for each of these kinds of users, along with 
              an explanation of why. 
            </p>

            <Typography variant='h5'>
              <strong>
                For Local users
              </strong>
            </Typography>
            <ul>
              <li>
                <strong>Login:</strong>
                (Required)
                We use this so we can uniquely identify you on the system.                
              </li>              
              <li>
                <strong>Password:</strong>
                (Required)
                We need this so you can prove who you are and prevent unauthorised access to your information.
              </li>
              <li>
                <strong>Email:</strong>
                (Optional)
                We need this so we can email you a new password if you forget it.
              </li>
            </ul>
                  
            <Typography variant='h5'>
              <strong>
                For OpenID users
              </strong>  
            </Typography>
            <ul>
              <li>
                <strong>OpenID: </strong>
                (Required)
                We use this to identify you on the system 
                so only you can access and update your pages.
              </li>
              <li>
                <strong>Nickname:</strong>
                (Optional)
                So we can identify you in a readable way. You can still use the service if you don't have this.              
              </li>
            </ul>

            <Typography variant='h4'>To withdraw your information</Typography>
            <p>
              You can withdraw your information at any time by signing in and
              deleting your account (Account, then Delete Account). To check
              what information you have provided, visit your user account
              (login, then click on the link with your nickname).
            </p>

            <Typography variant='h4'>Updates to this document</Typography>
            <p>
              We may make changes to this document from time to time (eg, in the event that
              new features require extra information we will need to add explanations here 
              for why they are needed. However, we will always retain the core principles of 
              this policy as stated in the first section.
            </p>
            <p>
              This policy was last updated on 30<sup>th</sup> April, 2022.
            </p>			
          </Container>
        </Box>
      </main>
    </React.Fragment>
  )
}

export default StaticPolicy
